import { createIcon } from './factory'
import Icon from './google-logo.svg?react'

export const GoogleLogo = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
